export enum LeadFormType {
  ZEUS = 'ZEUS',
  BATTERY = 'BATTERY',
  GOOGLE_SHEETS = 'GOOGLE-SHEETS',
  SOLAR_EDGE = 'LIGHTHOUSE-SOLAREDGE',
}

export const getFormType = (formType: string | undefined) => {
  return formType
    ? formType
        .toUpperCase()
        .replace(/\s*-\s*/g, '-')
        .replace(/\s+/g, '-')
    : LeadFormType.ZEUS;
};
